import { Link, useLocation } from 'react-router-dom';

interface CategoryTabsProps {
  categories: Array<{ slug: string; name: string }>;
  activeSlug: string;
  basePath?: string;
}

export default function CategoryTabs({ categories, activeSlug, basePath = '/category' }: CategoryTabsProps) {
  const location = useLocation();

  return (
    <div className="flex items-center gap-2 overflow-x-auto pb-1 flex-wrap" role="tablist">
      <Link
        to="/"
        role="tab"
        className={`px-4 py-2 text-sm rounded-full transition-colors whitespace-nowrap cursor-pointer ${
          location.pathname === '/'
            ? 'bg-primary-500 text-background-50 font-medium'
            : 'bg-background-100 text-foreground-600 hover:bg-background-200'
        }`}
      >
        全部
      </Link>
      {categories.map((cat) => (
        <Link
          key={cat.slug}
          to={`${basePath}/${cat.slug}`}
          role="tab"
          className={`px-4 py-2 text-sm rounded-full transition-colors whitespace-nowrap cursor-pointer ${
            activeSlug === cat.slug
              ? 'bg-primary-500 text-background-50 font-medium'
              : 'bg-background-100 text-foreground-600 hover:bg-background-200'
          }`}
        >
          {cat.name}
        </Link>
      ))}
    </div>
  );
}